import React, { Component } from 'react';
import classNames from 'classnames';
import { Checkbox } from 'antd';

class CheckboxField extends Component {
  render() {
    const {input, label, type, style } = this.props;
    if(type == 'int'){
      input.value = parseInt(input.value);
    }

    return (
      <div style={style} className={classNames("create-dialog-form__group create-dialog-form__group--indent-bottom")}>
        <Checkbox onChange={(e) => {
          let value = type == 'int' ? (e.target.checked ? 1 : 0) : e.target.value;
          input.onChange(value)
        }} checked={type == 'int' ? !!input.value : input.value}>{label}</Checkbox>
      </div>
    );
  }
}

export default CheckboxField;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/helpers/Fields/CheckboxField.jsx